export default "__VITE_ASSET__C_z05OOZ__"